import React from "react";

import { Card, CardContent } from "@material-ui/core";

import { Salario } from "src/utils/interfaces";
import { dividirEnDecimales } from "src/utils/texto";
import { formatearIntervalo } from "src/utils/fechas";

const Recibo: React.FC<{ salario: Salario }> = ({ salario }) => {
  return (
    <Card className="mt-2" key={salario.mes}>
      <CardContent>
        <div className="card-header d-flex justify-content-center">
          <span className="title color-garnet">{salario.mes}</span>
        </div>

        <div className="card-body">
          <div className="indice title mb-3">
            <span>Salario Bruto</span>
            <span></span>
            <span>Gs. {dividirEnDecimales(salario.bruto)}</span>
          </div>

          {salario.detalles.map((detalle) => (
            <div className="indice body-1" key={detalle.descripcion}>
              <span>{detalle.descripcion}</span>
              <span></span>
              <span>Gs. {dividirEnDecimales(detalle.valor)}</span>
            </div>
          ))}

          <div className="indice title color-garnet mt-3">
            <span>Neto Cobrado</span>
            <span></span>
            <span>Gs. {dividirEnDecimales(salario.neto)}</span>
          </div>

          {salario.horas?.length ? <hr className="my-3" /> : null}

          {salario.horas?.map((detalle) => (
            <div className="indice body-1" key={detalle.descripcion}>
              <span>{detalle.descripcion}</span>
              <span></span>
              <span>{formatearIntervalo(detalle.valor * 60)}</span>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
};

export default Recibo;
